const countryPolandOnly: { [key: string]: string } = {
  PL: 'Poland',
};

export default countryPolandOnly;
